import type { FacetLocation } from "./type";

export const activeFacet: { facetLocation: FacetLocation | null; openedFilterId: string | null } = $state({
  facetLocation: null,
  openedFilterId: null,
});

export function setFacetLocation(facetLocation: FacetLocation, openedFilterId: string | null) {
  activeFacet.facetLocation = facetLocation;
  activeFacet.openedFilterId = openedFilterId;
}

export function resetFacetLocation() {
  activeFacet.facetLocation = null;
  activeFacet.openedFilterId = null;
}
